import LangEnum from '../../../lang/LangEnum';
import { MediaZoomTypeEnum } from '../enums/mediaZoomType.enum';

type ZoomMappedOptions = {
  [key in MediaZoomTypeEnum]: {
    label: LangEnum;
    description: LangEnum;
  };
};

export const getMediaZoomTypeLabelAndDescription = (value: MediaZoomTypeEnum) => {
  const mappedLabel: ZoomMappedOptions = {
    IMMEDIATE_ZOOM: {
      label: LangEnum.GLOBAL_MEDIA_IMMEDIATE_ZOOM,
      description: LangEnum.GENERAL_SETTINGS_MEDIA_IMMEDIATE_ZOOM_DESCRIPTION,
    },
    PREVIEW_ZOOM: {
      label: LangEnum.GLOBAL_MEDIA_PREVIEW_ZOOM,
      description: LangEnum.GENERAL_SETTINGS_MEDIA_PREVIEW_ZOOM_DESCRIPTION,
    },
  };

  return mappedLabel[value];
};
